import { render } from "./LegalSourceCard.vue?vue&type=template&id=7f284b8b&scoped=true"
import script from "./LegalSourceCard.vue?vue&type=script&lang=js"
export * from "./LegalSourceCard.vue?vue&type=script&lang=js"

import "./LegalSourceCard.vue?vue&type=style&index=0&id=7f284b8b&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f284b8b"]])

export default __exports__